import { Country } from '~components/Input'
import type { CreateEvaluationParams } from '~services/evaluations.service'

import { RegistrationSchema } from '../models/registration.model'

interface Values extends RegistrationSchema {
  countryCode: Country
}

export const adaptRegistrationFormValuesToService = (
  formValues: Values,
): CreateEvaluationParams => {
  return {
    country: 'México',
    dialCode: formValues.countryCode.value,
    email: formValues.email,
    name: `${formValues.firstName} ${formValues.lastName}`,
    phone: formValues.phone,
  }
}
